import React from "react";
import Loader from 'react-loader-spinner'
// import FilterViewer from "../FilterViewer";
import Modal from "../components/Modal";
import { translate } from "../utils/useful";
import FilterViewer from "../components/FilterViewer";


class FilterModal extends React.Component {
  state = {
    isLoadingRemove: false,
    id: null,
    index: null
  }

  showModal = (id, index) => {
    this.setState({ id, index,filters:this.props.initData })

    this.modal.showModal()
  }

  changeFilter = (key, value, extra) => {

    // console.log(extra)
    // console.log(extra)

    let filters = this.state.filters
    if (!filters) filters = {}
    if ( value == null) {
      delete filters[key]
    } else {
      value = value
      filters[key] = { key, value, operator: extra.operator, type: extra.type, label: extra.label,dictionary:extra.dictionary }
    }

    this.setState({ filters }, () => {
      console.log(filters)
    })
  }


  doFilter = () => {
    // console.log(this.state.filters)


    let filters = this.state.filters

    for (const [key, value] of Object.entries(this.state.filters)) {
      // console.log(value.type)
      if (value.type == 'PhoneInput' && value.value?.length <= 4) {
        delete filters[key]
      }

    }


    this.props.doFilter({ ...filters })
  }





  render() {
    return (
      <Modal maxWidth={500} ref={el => this.modal = el}>

        <div className="pb-5 w-100 h-100">
          <div className="w-100 h-100" style={{ backgroundColor: '#fff', overflow: 'auto', borderRadius: 8 }}>
            {/* <div className="text-center" style={{ backgroundColor: '#fff', borderRadius: 8 }}> */}
            <div className="w-100" style={{ zIndex: 1, padding: '12px 22px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '0px #eee solid', backgroundColor: '#f2f6f8ee', background: 'linear-gradient(to right,#d7e2f7dd,#dad6e4dd)', backdropFilter: 'blur(10px) saturate(180%)', WebkitBackdropFilter: 'blur(10px) saturate(180%)', borderRadius: '8px 8px 0px 0px' }}>

              <p className="text-bold mb-0 text-normal ">Advanced Search</p>

              <div className="cursor-pointer" onClick={() => this.modal.hideModal()} style={{ width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img style={{ width: 14, height: 14 }} src="/images/close.svg" alt="" />
              </div>

            </div>
            <div className="pt-2 px-3 pb-2">
              <FilterViewer changeFilter={this.changeFilter} headers={this.props.headers} data={this.state.filters} errors={this.state.errors} inputClass={'modern-input'} />


              <div className="mt-2 blur-back pb-2" style={{ position: 'sticky', bottom: 0, backgroundColor: '#ffffffbb', zIndex: 4 }}>
                {!this.props.isLoading && (
                  <div className="flexcc mt-2 w-100">

                    <button className="w-100 m-1 p-2 px-4 white text-bold text-uppercase" onClick={() => this.modal.hideModal()} style={{ borderRadius: 6, backgroundColor: '#789', }}>
                      <p className="text-normal text-uppercase">{translate("cancel")}</p>
                    </button>

                    <button className="w-100 m-1 p-2 px-4 white text-bold text-uppercase" onClick={() => { this.doFilter() }} style={{ backgroundColor: '#677dc4', borderRadius: 6, }}>
                      <p className="text-normal text-uppercase">{translate('Submit')}</p>
                    </button>
                  </div>
                )}
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  {this.props.isLoading && (
                    <Loader
                      type="Puff"
                      color="rgba(0,122,255,1)"
                      height="40"
                      width="40"
                    />)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}



export default FilterModal;
